// ------------------------------------------------
// |                                               |
// |    Strictly do not format the whole code      |
// |                                               |   
// ------------------------------------------------

// Import Redux/toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";

// Import AuthConfig
import authConfig from "../../configs/auth";

// Import API endpoints
import { ApiEndPoints } from "src/network/endpoints";

// Import AxiosInstance
import { axiosInstance } from "src/network/adapter";
import toast from "react-hot-toast";
import axios from "axios";

const login = createAsyncThunk(
  "auth/login",
  async (data, { rejectWithValue }) => {
    // const { email, password, pushToken, device } = data;
    try {
      // Step 1: Perform login
      const response = await axiosInstance.post(ApiEndPoints.AUTH.login, data);
      console.log("Login response", response.data);
      const { accessToken, refreshToken, user, financePermissions, financeRole } = response.data.data;

      // Step 2: Store tokens in localStorage
      window.localStorage.setItem(authConfig.storageTokenKeyName, accessToken);
      window.localStorage.setItem(authConfig.storageRefreshTokenKeyName, refreshToken);

      // Step 3: Call Me API to get the latest user data
      const meResponse = await axios.get(ApiEndPoints.AUTH.me, { headers: { Authorization: `Bearer ${accessToken}`, userid: user?.id } });

      // Step 4: Merge financePermissions from login response into the user profile
      const profileData = meResponse.data.data;
      const updatedUser = {
        ...profileData,
        financeAdminRole: {
          ...(profileData?.financeAdminRole || {}),
          id: financeRole,
          permissions: financePermissions,
        },
      };
      window.localStorage.setItem(authConfig.storageUserDataKeyName, JSON.stringify(updatedUser));

      toast.success(response.data?.message || "Login successful");
      // Step 5: Return the updated user object
      return { user: updatedUser };
    } catch (error) {
      toast.error(error.response?.data?.message)
      return rejectWithValue(error.response?.data?.message || "Login failed");
    }
  }
);

const fetchUser = createAsyncThunk(
  "auth/fetchUser",
  async ({ storedToken }, { rejectWithValue }) => {
    // const storedToken = window.localStorage.getItem( authConfig.storageTokenKeyName );
    if (!storedToken) {
      return rejectWithValue("No token found");
    }
    try {
      const response = await axiosInstance.get(ApiEndPoints.AUTH.me, { headers: { Authorization: `Bearer ${storedToken}` } });
      const profileData = response.data.data;
      // Restore merged permissions from localStorage if me endpoint doesn't include them
      const stored = window.localStorage.getItem(authConfig.storageUserDataKeyName);
      const storedUser = stored ? JSON.parse(stored) : null;
      if (storedUser?.financeAdminRole?.permissions && !profileData?.financeAdminRole?.permissions) {
        return {
          ...profileData,
          financeAdminRole: {
            ...(profileData?.financeAdminRole || {}),
            permissions: storedUser.financeAdminRole.permissions,
          },
        };
      }
      return profileData;
    } catch (error) {
      window.localStorage.removeItem(authConfig.storageTokenKeyName);
      window.localStorage.removeItem(authConfig.storageRefreshTokenKeyName);
      window.localStorage.removeItem(authConfig.storageUserDataKeyName);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch user"
      );
    }
  }
);

export { login, fetchUser };
